import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { isError } from "@nju/result";
import { IInvoiceResult } from "./types";
import { serverResponse } from "./validators";

export async function fetchUnpaidInvoices(): Promise<IInvoiceResult> {
  const result = await client(
    `${
      process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST || "unknown"
    }/users/invoices`,
    {
      method: "get",
      validator: serverResponse,
      headers: {
        version: "2",
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
      },
      searchParams: {
        paymentStatus: "NOT_PAID,PENDING",
      },
    },
  );

  if (isError(result)) {
    Bugsnag.notify(result.err);
    return result;
  }

  return result;
}
